
// import React, { useState } from "react";
// import { Outlet } from "react-router-dom";
// import Sidebar from "./AdminSidebar";
// import AdminHeader from "./AdminHeader";

// const AdminLayout = () => {
//   const [collapsed, setCollapsed] = useState(false);
//   const [mobileOpen, setMobileOpen] = useState(false);

//   return (
//     <div className="flex flex-col h-screen overflow-hidden">
//       {/* HEADER */}
//       <AdminHeader setMobileOpen={setMobileOpen} />

//       {/* BODY */}
//       <div className="flex flex-1 overflow-hidden relative">
//         {/* SIDEBAR */}
//         <Sidebar
//           collapsed={collapsed}
//           setCollapsed={setCollapsed}
//           mobileOpen={mobileOpen}
//           setMobileOpen={setMobileOpen}
//         />

//         {/* CONTENT */}
//           <main id="admin-scroll-area" className="flex-1 overflow-auto p-4 md:p-6 bg-[#fafbfc]">

//           <Outlet />
//         </main>
//       </div>
//     </div>
//   );
// };

// export default AdminLayout;


import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "./AdminSidebar";
import AdminHeader from "./AdminHeader";

const AdminLayout = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <div className="flex flex-col h-screen overflow-hidden">
      <AdminHeader mobileOpen={mobileOpen} setMobileOpen={setMobileOpen} />

      {/* BODY */}
      <div className="flex flex-1 overflow-hidden relative">
        {/* SIDEBAR */}
        <Sidebar
          collapsed={collapsed}
          setCollapsed={setCollapsed}
          mobileOpen={mobileOpen}
          setMobileOpen={setMobileOpen}
        />

        {/* CONTENT */}
        <main id="admin-scroll-area" className="flex-1 overflow-auto p-4 md:p-6 bg-[#fafbfc]">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;